import useSWR from "swr";
import { useContext } from "react";
import Settings from "../../../settings";
import {
  CurrentPriceResponse,
  fetcher,
  isinUrl,
  REFRESH_TIME_LONG,
} from "../../data";
import { numberWithCommas } from "../../formatters";
import { format } from "date-fns/esm";

const MiniSharePrice = () => {
  const { getSetting } = useContext(Settings);

  const { data } = useSWR<CurrentPriceResponse>(
    isinUrl("price", getSetting("sharePrice.isin")),
    fetcher,
    { refreshInterval: REFRESH_TIME_LONG }
  );

  if (!data) return null;

  const fetched = data?.current.isoTimestamp
    ? new Date(data.current.isoTimestamp)
    : null;

  return (
    <div className="shareprice-mini">
      <p className="shareprice-mini__value">
        {numberWithCommas(data.current.close)}
        {getSetting("sharePrice.currency")}
      </p>
      <ul className="shareprice-mini__meta">
        <li className="shareprice-mini__meta-item">
          <span className="shareprice-mini__meta-value">
            {numberWithCommas(data.current.high)}
          </span>
          <span className="shareprice-mini__meta-key">High</span>
        </li>
        <li className="shareprice-mini__meta-item">
          <span className="shareprice-mini__meta-value">
            {numberWithCommas(data.current.low)}
          </span>
          <span className="shareprice-mini__meta-key">Low</span>
        </li>
        <li className="shareprice-mini__meta-item">
          <span className="shareprice-mini__meta-value">
            {numberWithCommas(data.current.volume)}
          </span>
          <span className="shareprice-mini__meta-key">Volume</span>
        </li>
      </ul>
      <p className="sharePrice-valueDate">
        at {format(fetched, getSetting("sharePrice.dateFormat"))}
      </p>
    </div>
  );
};
export default MiniSharePrice;
